let vm = null;

export const sendThis = (_this) => {
  vm = _this;
};
export const delay = (function () {
  let times = 0;
  return function (callback, ms) {
    clearTimeout(times);
    times = setTimeout(callback, ms);
  };
})();
export const checkTitle = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('名称不能为空'));
  }
  setTimeout(() => {
    const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
    if (reg.test(value)) {
      const len = value.replace(/[^\x00-\xff]/g, 'aa').length;
      if (len < 1 || len > 12) {
        return callback(new Error('仅支持6个中文字符12个英文字符'));
      }
      return callback();
    }
    return callback(new Error('仅支持中英文和数字'));
  }, 1000);
};
export const checkUrl = (rule, value, callback) => {
  const reg = /(https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?/;
  if (vm.form.type === 10) {
    if (!value) {
      return callback(new Error('地址不能为空'));
    }
    if (reg.test(value)) {
      return callback();
    }
    return callback(new Error('请输入正确的网址(例：https://xxx.com)'));
  }
  return callback();
};
export const checkIcon = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请上传图标'));
  }
  return callback();
};
export const checkAppId = (rule, value, callback) => {
  if (!value && vm.form.type === 20) {
    return callback(new Error('app_id不能为空'));
  }
  return callback();
};
export const acheckAppPath = (rule, value, callback) => {
  const reg = /^[A-Za-z0-9_-]+[/]+[A-Za-z0-9_-]/;
  if (vm.form.type === 20) {
    if (!value) {
      return callback(new Error('路径不能为空'));
    }
    if (reg.test(value)) {
      return callback();
    }
    return callback(new Error('请输入正确的路径(例：pages/index/index)'));
  }
  return callback();
};
